import React, { FunctionComponent } from "react";
import { IIconProps } from "./icon";

export const LaboratoryIcon: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg viewBox="0 0 24 24" {...rest}>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Icons/Base/Laboratory" stroke={color ? color : "#222222"} strokeWidth="2">
          <g id="Group" transform="translate(3.339000, 1.000000)">
            <path
              d="M13.4078129,7.76626717 C14.4182955,8.87583449 15.0106901,10.3148201 15.0633912,11.8321921 C15.1256426,13.6245365 14.4291013,15.3600186 13.145,16.612 C10.5631938,19.1287642 6.44580625,19.1287642 3.864,16.612 C3.12109173,15.8853981 2.5661303,14.9889484 2.247,14"
              id="Path"
            ></path>
            <path
              d="M10.748,10.23 C10.3793068,10.5900088 9.79069323,10.5900088 9.422,10.23 L8.096,8.93 C7.92105627,8.75897565 7.82243764,8.52465207 7.82243764,8.28 C7.82243764,8.03534793 7.92105627,7.80102435 8.096,7.63 L12.073,3.72 C12.4416932,3.35999116 13.0303068,3.35999116 13.399,3.72 L14.725,5.02 C14.8999437,5.19102435 14.9985624,5.42534793 14.9985624,5.67 C14.9985624,5.91465207 14.8999437,6.14897565 14.725,6.32 L10.748,10.23 Z"
              id="Path"
            ></path>
            <polyline id="Path" points="13.879 4.19 16.567 1.5 15.067 0"></polyline>
            <line x1="18.067" y1="3" x2="16.567" y2="1.5" id="Path"></line>
            <line x1="0" y1="14" x2="5.25" y2="14" id="Path"></line>
            <line x1="0.817" y1="21.5" x2="15.067" y2="21.5" id="Path"></line>
            <line x1="8.317" y1="18.5" x2="8.317" y2="21.5" id="Path"></line>
          </g>
          <path
            d="M5.1708,3.0936444 C5.13449979,3.03548855 5.06977147,3 5,3 C4.93022853,3 4.86550021,3.03548855 4.8292,3.0936444 C4.1936,4.11026431 2,7.69849533 2,9.07194727 C2,10.6890661 3.34314575,12 5,12 C6.65685425,12 8,10.6890661 8,9.07194727 C8,7.69849533 5.8064,4.1098739 5.1708,3.0936444 Z"
            id="Path"
          ></path>
        </g>
      </g>
    </svg>
  );
};
